import { render } from "./Aliplayer.vue?vue&type=template&id=02bc5dba&scoped=true"
import script from "./Aliplayer.vue?vue&type=script&lang=js"
export * from "./Aliplayer.vue?vue&type=script&lang=js"

import "./Aliplayer.vue?vue&type=style&index=0&id=02bc5dba&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02bc5dba"]])

export default __exports__